import { render, staticRenderFns } from "./pcPublicHeader.vue?vue&type=template&id=8e3c5724&scoped=true"
import script from "./pcPublicHeader.vue?vue&type=script&lang=js"
export * from "./pcPublicHeader.vue?vue&type=script&lang=js"
import style0 from "./pcPublicHeader.vue?vue&type=style&index=0&id=8e3c5724&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3c5724",
  null
  
)

export default component.exports